import React, { useEffect, useState } from "react";
//import { db, storage } from "../firebase"; // Assuming you have set up Firebase
import { auth, db, storage } from "../firebase"; // Import your Firebase Firestore instance
import { onAuthStateChanged } from "firebase/auth";
import { ref, listAll, getDownloadURL } from "firebase/storage";
import {
  collection,
  query,
  where,
  getDocs,
  doc,
  setDoc,
} from "firebase/firestore";
import { Container, Row, Button, Col } from "react-bootstrap";
import { useNavigate, Link } from "react-router-dom";
import AiPainting from "../images/aiPainting.jpg";
import { formatPhoneNumber } from "../functions/formatFunctions";
import { FaCheck } from "react-icons/fa";
//import { MdCheck } from "react-icons/md";
import { motion } from "framer-motion";
import Skeleton from "./Skeleton";
import {
  syncImageUrls,
  getStorageUrls,
  updateDisplayName,
} from "../functions/syncImages";
import GalleryProfile from "./GalleryProfile";

const UserProfile = ({
  user,
  folderName,
  setFolderName,
  imageUrls,
  setImageUrls,
  docId,
  setDocId,
}) => {
  const [userData, setUserData] = useState(null);
  const [roleIsMember, setRoleIsMember] = useState(false);
  const [suggestBioGen, setSuggestBioGen] = useState(false);
  const navigate = useNavigate();
  const imageFolder = localStorage.getItem("fullName");
  const [imageNumber, setImageNumber] = useState("0");
  const [noUserInfo, setNoUserInfo] = useState("true");
  let numberOfImages = 0;

  setFolderName(imageFolder);

  getStorageUrls(folderName)
    .then((storageUrls) => {
      if (storageUrls && docId) {
        const collectionName = "artists";
        sessionStorage.setItem("docId", docId);
      } else {
        console.log("Waiting++++");
      }
    })
    .catch((error) => {
      console.error("Error while getting URLs from storage:", error);
    });

  useEffect(() => {
    if (user) {
      // Use onAuthStateChanged to listen for changes in the authentication state
      const unsubscribe = onAuthStateChanged(auth, async (authUser) => {
        if (authUser) {
          // User is signed in, set the user state
          const userUid = authUser.uid;
          console.log(Object.entries(authUser)); // [["name", "John"], ["age", 30]]
          //console.log(Object.values(authUser)); // ["John", 30]
          // Create a reference to the 'artists' collection
          const artistsCollectionRef = collection(db, "artists");
          // Create a query to find the document with the matching 'authRegID'
          const q = query(
            artistsCollectionRef,
            where("authRegID", "==", userUid)
          );
          try {
            const querySnapshot = await getDocs(q);
            if (!querySnapshot.empty) {
              const userData = querySnapshot.docs[0].data();
              const docId = querySnapshot.docs[0].id;
              setDocId(docId);
              setUserData(userData);
              setNoUserInfo(false);
              const fullFolderName =
                userData.first_name + "_" + userData.last_name;
              localStorage.setItem("fullName", fullFolderName);
              const fullName = userData.first_name + " " + userData.last_name;
              sessionStorage.setItem("firstName", userData.first_name);
              sessionStorage.setItem("userFullName", fullName);
              const bar = localStorage.getItem("userFullName");
              const role = userData.role;
              if (role === "member") {
                setRoleIsMember("true");
              } else if (role === "guestArtist") {
                setRoleIsMember("false");
                console.log("this is roleIsMember", roleIsMember);
              }
              const newDisplayName = userData.first_name;
              console.log("NewDisplayName", newDisplayName);
              updateDisplayName(user, userData.first_name);
              // const numberOfImages=0;
              //imageUrls.length
              //console.log("Urls length ", userData.imageURLs.length);

              if (userData.imageURLs) {
                numberOfImages = userData.imageURLs.length;
                setImageNumber(numberOfImages);
              } else {
                setImageNumber(numberOfImages);
                console.log("Number of Images", imageNumber);
              }

              // setImageNumber(numberOfImages);
              console.log("Number of Images", imageNumber);
              //setImageUrls(userData.imageURLs);
              //console.log("From state imageUrls", imageUrls);
              if (userData.bio.length < 20) {
                setSuggestBioGen(true);
                console.log("Less than 20");
              } else {
                setSuggestBioGen(false);
                console.log("Bio is a great length");
              }
            } else {
              // No matching document found
              setUserData(null);
              setNoUserInfo(true);
              alert("Sorry, We can't find any information");
              navigate("/");
            }
          } catch (error) {
            console.error("Error fetching user data:", error);
            setUserData(null);
          }
        } else {
          // User is signed out, clear the user data
          setUserData(null);
        }
      });
      // Clean up the subscription when the component unmounts
      return () => unsubscribe();
    }
    // }, [user, imageUrls]);
  }, [user]);

  return (
    <Container className='mt-4'>
      <Row className='mt-3 d-flex'>
        <Col className='whiteText mt-4'>
          {user ? (
            <div>
              <div className='d-flex justify-content-between align-middle'>
                <div className='mb-5'>
                  {" "}
                  <h1>Welcome {userData?.first_name}!</h1>
                </div>
                {roleIsMember === "false" && (
                  <div>
                    {" "}
                    <Button
                      className='btn btn-primary mb-4'
                      onClick={() => navigate("/SignOut")}>
                      Finish & Save Submission
                    </Button>
                  </div>
                )}
              </div>
              {roleIsMember === "false" && (
                <h5>
                  As a candidate for the Guest Artist Showcase here are your
                  next steps to complete your submission.
                </h5>
              )}

              {imageNumber === 0 && (
                <p>
                  {" "}
                  <FaCheck
                    size={12}
                    style={{ marginRight: "5px", color: "green" }}
                  />
                  Upload some of your work to your gallery.&nbsp;&nbsp;&nbsp;
                  <button
                    className='btn btn-small'
                    onClick={() => navigate("/Gallery")}>
                    Upload to Gallery
                  </button>
                </p>
              )}
              {!noUserInfo && (
                <p>
                  {" "}
                  <FaCheck
                    size={12}
                    style={{ marginRight: "5px", color: "green" }}
                  />
                  Please check the info below for accuracy.&nbsp;&nbsp;&nbsp;
                  <button
                    className='btn btn-small'
                    onClick={() => navigate("/EditUserProfile")}>
                    Edit Profile
                  </button>
                </p>
              )}

              {imageNumber > 0 && (
                <p>
                  <FaCheck
                    size={12}
                    style={{ marginRight: "5px", color: "green" }}
                  />
                  You've uploaded {imageNumber} images to your gallery. You can
                  upload {7 - imageNumber} more.{" "}
                  <button
                    className='btn btn-small'
                    onClick={() => navigate("/Gallery")}>
                    Upload to Gallery
                  </button>
                </p>
              )}

              {userData ? (
                <>
                  <div className='user-card'>
                    <Row className='mb-4'>
                      <p>
                        <span className='bold'>
                          {userData?.first_name} {userData?.last_name}{" "}
                        </span>
                        <br></br>
                        Email: {userData?.email}
                        <br></br>
                        Phone: {formatPhoneNumber(userData?.phone)}
                        <br></br>
                        Website: {userData?.website}
                        <br></br>
                        Instagram: {userData?.instagram}
                        <br></br>
                        Facebook: {userData?.facebook}
                        <br></br>
                        Registered as:{" "}
                        {userData?.role === "guestArtist"
                          ? "Guest Artist"
                          : "Member Artist"}{" "}
                        <br></br>
                        <br></br>
                        Bio: {userData?.bio}
                        <br></br>
                      </p>
                    </Row>
                  </div>
                  {suggestBioGen && (
                    <div className='mt-4 mb-3'>
                      <h6 className='white-text pb-2'>
                        We see you haven't entered a bio. Try our AI powered Bio
                        Writer. Seven easy questions. One great bio.
                      </h6>
                      <span>
                        <Button
                          size='sm'
                          variant='btn btn-primary'
                          onClick={() => navigate("/BioGenerator")}>
                          Give It a Try It!
                        </Button>
                      </span>
                    </div>
                  )}
                </>
              ) : (
                //this is like a fancy loader
                <Skeleton />
              )}
            </div>
          ) : (
            //loader just in case we can't find user
            <>
              {" "}
              <Skeleton />
            </>
          )}
        </Col>
        {imageNumber === -1 && (
          <Col lg={6} className='text-center'>
            <img src={AiPainting} alt='Artist Showcase' className='img-fluid' />
          </Col>
        )}{" "}
        {imageNumber > 0 && roleIsMember === "false" && (
          <h3 className='mt-4'>
            These are the images we'll use for your submission.
          </h3>
        )}
        {imageNumber > 0 && roleIsMember === "true" && (
          <h3 className='mt-4'>These are the images in your gallery.</h3>
        )}
        {imageNumber > 0 && <GalleryProfile imageUrls={imageUrls} />}
      </Row>
    </Container>
  );
};

export default UserProfile;
